import { Link } from "react-router-dom";

const GENRE_ICONS: Record<string, string> = {
  热血: "ri-fire-fill",
  恋爱: "ri-heart-fill",
  奇幻: "ri-magic-fill",
  悬疑: "ri-spy-fill",
  科幻: "ri-planet-fill",
  校园: "ri-graduation-cap-fill",
  都市: "ri-building-2-fill",
  搞笑: "ri-emotion-happy-fill",
  历史: "ri-ancient-gate-fill",
  恐怖: "ri-ghost-fill",
};

const GENRE_TINTS: string[] = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
];

interface GenreNavProps {
  genres: string[];
}

export default function GenreNav({ genres }: GenreNavProps) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
      {genres.map((genre, i) => (
        <Link
          key={genre}
          to={`/category?genre=${encodeURIComponent(genre)}`}
          className="group flex flex-col items-center justify-center gap-2 py-4 md:py-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span
            className={`w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${GENRE_TINTS[i % GENRE_TINTS.length]}`}
          >
            <i className={`${GENRE_ICONS[genre] ?? "ri-bookmark-fill"} text-xl md:text-2xl`}></i>
          </span>
          <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
            {genre}
          </span>
        </Link>
      ))}
    </div>
  );
}